import * as Yup from "yup";
import form from "./form";

const {
	formField: { emails },
} = form;

const validations = Yup.object().shape({
	[emails.name]: Yup.string().required(emails.errorMsg),
});

export default validations;
